import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { fetchOnboarding, updateOnboarding, type OnboardingStepKey } from '@/api/onboarding'
import { track } from '@/lib/analytics'

export function useOnboarding() {
  const queryClient = useQueryClient()

  const query = useQuery({
    queryKey: ['onboarding'],
    queryFn: fetchOnboarding,
    // Steps are derived from data that changes elsewhere in the app; re-check every time
    // the Dashboard mounts so a step completed on another page shows ticked on return,
    // even for paths that don't invalidate ['onboarding'] themselves (e.g. accepting an
    // invite, or a co-owner adding the first account).
    refetchOnMount: 'always',
  })

  const mutation = useMutation({
    mutationFn: updateOnboarding,
    onSuccess: (state, change) => {
      queryClient.setQueryData(['onboarding'], state)
      if ('skip' in change) track('onboarding_step_skipped', { step: change.skip })
      else track('onboarding_dismissed')
    },
  })

  return {
    ...query,
    skipStep: (key: OnboardingStepKey) => mutation.mutate({ skip: key }),
    dismissAll: () => mutation.mutate({ dismiss: true }),
    isUpdating: mutation.isPending,
  }
}
